module.exports = __webpack_public_path__ + "static/media/hand.2822211f.svg";